import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as wjcCore from '@grapecity/wijmo';
import initLocalization from "./lib/common/initLocalization";
import { kstDateToJSON } from "./lib/common/dateFormat";

// API 로 보내는 Date 는 DB 와 같은 KST 벽시계 문자열로 — 프론트의 유일한 시간대 변환 자리(UTC ISO 로 보내지 않는다)
// eslint-disable-next-line no-extend-native
Date.prototype.toJSON = kstDateToJSON;
// import 'mutation-events';

// mutation-events 대체 - wijmo를 속여 warning 출력 방지
if (typeof window.MutationEvent === 'undefined') {
    window.MutationEvent = function () {}; // 빈 함수로 대체
}

wjcCore.setLicenseKey("gen-mom-cloud,316715877358464#B0JAUMy8CMwIjLwEDLt36Yu46bthXakFmcuAHchxSbvNmLtJXb8lGZhJHLwYjLwATMugjNx8iM9EDLyYjLwATMugjNx8iM9EDLt36Yu46bthXakFmcuc7d7xiM68CN98SO78SM6wSM78yMx8CMwIjLwEDLt36bj9Sbv5GepRWYy9yd7dHLt36Yu46bthXakFmcsYTMy8yM58iNx8iM7EDLzEjMuMTNuYTMuIzNxwSMuATMuETMuATMsMjNuADMx8CO6EjLykTMsUzMx8yM58iNx8iM7EjI0IyctRkIsIiLj9WSgg6YlRXYpJXQiojIh94QiwiI4YDN8UzM7cDO5EzN6EzMiojIklkIs4XXbpjInxmZiwiIyYXMyAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TUOJ7diVGTvVVQSdEM8IzKqJEZktGOy34ciVHSSFUdvkkeL9mcoVXdVd5Rsl4LClkSWhjd6w6LZN6KIZ6MWNTbp54dJJGdXZlQro7bCVlNzR7avhkbXtiT9cTchx4csBzbmtSUlNVUsZ6K5xWOPhUYMdUdlhUYFZFdLF7KOJTR4cUW0lEakVTT4lUNPN5Qz56aT3mbLZmQrYlUTZEePZWMqJ4Uvlmaxk7aId6MYhjauh5YrNkQ9tmQmR4U8c4Z5oWNWFzSYNVTHVzRwEjaZNETj9kUJJ6QHhkNChXditkWXpEdnZHc7kWZ9FTbYB5MvN4V89mS5UlS0pFMRRXRrJ4NrYUS0h5N4dUQSJTORFVVBNWcUVGe4EkWFBnW8RHVTZUOx2CNNFTZGtibuREe4tiRlJ5ZHFWZ53WOUNESOpFSENVVxhGTMdTdMF4RZJHZxUGdCRXNUhmI0IyUiwiIzcjNyIzMEZjI0ICSiwSNzQzNwYzMwAjM0IicfJye#4Xfd5nIJBjMSJiOiMkIsIibvl6cuVGd8VEIgQXZlh6U8VGbGBybtpWaXJiOi8kI1xSfiUTSOFlI0IyQiwiIu3Waz9WZ4hXRgAicldXZpZFdy3GclJFIv5mapdlI0IiTisHL3JyS7gDSiojIDJCLi86bpNnblRHeFBCI73mUpRHb55EIv5mapdlI0IiTisHL3JCNGZDRiojIDJCLi86bpNnblRHeFBCIQFETPBCIv5mapdlI0IiTisHL3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTisHL3JSV8cTQiojIDJCLi86bpNnblRHeFBCI4JXYoNEbhl6YuFmbpZEIv5mapdlI0IiTis7W0ICZyBlIsISO5QTN6ADI4EDMxYjMwIjI0ICdyNkIsISbvNmLtJXb8lGZhJnL7d7ds46bj9Sbv5GepRWYy9idlRGL4EjMuMTNuYTMuIzNxwyNxIjLzUjL6EjLycTMsETMugjNx8CO6EjLykTMs2GduQ7Yl9mbvN6ajlWdx9yMyYDMp3Gaj9WaqlHLxQTMuMTNuYTMuIzNxwyMz8yN4IjL6gTMuITMxwCO48yM58iNx8iM7EDL58CMugjNx8iM9EDLt36Yu46bthXakFmcuQGbv5GLz8CMx8SMx8CMxwSbvNmLt3Wb8lGZhJnL4FWbllHLt36YuMXZt5WYu36asQ7cvhGbhN6bsxSbvNmLzdXYu3meh5WYuUGd5BXbvNmLy4CdzFWZoRncv9WLwFmL7gTLwEjMtYzMtMTLyMWZsEjNuADMx8CO6EjLykTMsIjLwEjLxEjLwEDLt36YuMXZt5WYu36auEmbvtGLxMjMuMTNuYTMuIzNxwCOx8yMyEjL8YTMuITOxwiMy8SMugjNx8iM9EDLyIjLzUjL6EjLycTMscDOuATMy8iNz8yMtESM");

( async () => {

    await initLocalization();
    
} ) ();

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
